import React from 'react';

import queryString from 'query-string';
import { useLocation } from 'react-router';

import { apiHost } from '../api/api';

import { END_TO_END_TOKEN_KEY } from './get-end-to-end-user-tokens';

import { DOMAIN, isProd } from '../config/config';
import { LocalStorageController } from '../util/local-storage-controller';

export const EndToEndUserLogin = () => {
  const { search } = useLocation();

  if (isProd) {
    return null;
  }

  const params = queryString.parse(search);
  const { username, startingLocation } = params;
  if (!username || Array.isArray(username)) {
    return null;
  }
  if (startingLocation && Array.isArray(startingLocation)) {
    return null;
  }

  // Purposefully use the raw fetch option here since our api.ts file expects to be used
  // only in an authenticated manner
  fetch(`${apiHost()}/api/end-to-end-tests/login-user?username=${username}`)
    .then((resp) => resp.json())
    .then((resp) => {
      // This is the key step - setting this token in local storage means it'll be used
      // downstream by the app
      LocalStorageController.setItem(END_TO_END_TOKEN_KEY, resp.token);

      window.location.href = startingLocation || DOMAIN;
    });

  return <div>Loading User...</div>;
};
